"use client";

import Swiper, { SwiperSlide } from "@/components/ui/swiper";
import Title from "@/components/ui/title";
import { useScopedI18n } from "@/messages/client";

export default function WhyChoose(props: {
  data?: {
    title?: string;
    description?: string;
  }[];
}) {
  const t = useScopedI18n("POWERQUARK简介");
  return (
    <div className="w-full">
      <Title className="font-semibold" title={t("为什么选择POWERQUARK")} underline={false} />
      <Swiper
        className="mt-5 md:mt-16"
        slidesPerView={1}
        navigation
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        speed={1000}
      >
        {props.data?.map((el, index) => (
          <SwiperSlide key={index}>
            <div className="flex flex-col justify-center items-center">
              <p className="text-lg text-primary md:text-4xl md:leading-normal">{el.title}</p>
              <p className="mt-1 px-10 text-sm text-center md:mt-3 md:text-2xl">{el.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
